/*****************************************************************************/
/*  File Name: timeRangeCalculations.js                                      */
/*  Date:      June 27, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the bar that will show the users the calculations 
/*             based on their selection on the timeRangeBar
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import { useROIContext } from '../../context/roiContext';
import { convertToCurrency } from '../../functions/convertCurrency';
import styles from './styles/roi.module.scss';
import * as MODES from '../../constants/modes';

function TimeRangeCalculations({ t }) {
  //Load all of the default component varaibles

  const { selectedTimeBreakdown, timeRangePracticeRevenue, timeRangeTreatmentCosts, timeRangeProfit, roiMode, consumerTreatmentCost, consumerPracticeRevenue, consumerTreatmentProfit } = useROIContext();

  return (
    <Grid item xs={12} container className={styles.priceGrid} alignItems='flex-end' alignContent='center' justifyContent='center'>
      <Grid item xs={12} sm={4}>
        <Grid item xs={12} className={styles.title}>
          {roiMode === MODES.consumer ? 'Current' : ''} {selectedTimeBreakdown} Practice Revenue
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(roiMode === MODES.consumer ? consumerPracticeRevenue : timeRangePracticeRevenue())}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Grid item xs={12} className={styles.title}>
          {roiMode === MODES.consumer ? 'Current' : ''} Total {selectedTimeBreakdown} Costs
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(roiMode === MODES.consumer ? consumerTreatmentCost : timeRangeTreatmentCosts())}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Grid item xs={12} className={styles.title}>
          {roiMode === MODES.consumer ? 'Current' : ''} Total {selectedTimeBreakdown}
          <br /> Profit
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(roiMode === MODES.consumer ? consumerTreatmentProfit : timeRangeProfit())}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withTranslation()(TimeRangeCalculations);
